export default __webpack_public_path__ + "6660fab6335c18fffaae4456bfc09b67.svg";